import React, { useState } from "react";
import axios from "axios";
import Costanti from "../../constantiX";
import { Formik } from "formik";
import * as Yup from "yup";

import { InputText, InputTextarea, Button, FileUpload, Dropdown, Toast, RadioButton } from "primereact";
import ReactGA from "react-ga4";
class Fornitore extends React.Component {
  constructor() {
    super();
    this.state = { xcarica: "sezione", dati: [], fornitore: {}, visible3: false, editMode: true };
    this.token = sessionStorage.getItem("ICEtoken");
    this.utente = JSON.parse(sessionStorage.getItem("utente"));
    this.id = 0;
    this.tipo = "V";
  }

  showMessage(tipo, messageError, dettaglio) {
    var icona = "";
    if (tipo == "error") {
      icona = "pi pi-times-circle";
    }
    if (tipo == "info") {
      icona = "pipi-info-circle";
    }
    if (tipo == "success") {
      icona = "pi pi-check-circle";
    }
    if (tipo == "warning") {
      icona = "pi pi-exclamation-triangle";
    }
    this.toastBC.show({
      severity: tipo,
      life: 3000,
      closable: false,
      content: (
        <div className="flex flex-column" style={{ flex: "1" }}>
          <div className="text-center">
            <i className={icona} style={{ fontSize: "3rem" }}></i>
            <h4>{messageError}</h4>
            <h5>{dettaglio}</h5>
          </div>
        </div>
      ),
    });
  }
  setEditMode(val) {
    this.setState({ editMode: val });
  }

  componentDidMount() {
    //alert(this.props.location.pathname);
    //ReactGA.send({ hitType: "pageview", page: this.props.location.pathname });
    var id = this.props.match.params.id;
    var tipo = this.props.match.params.tipo;
    this.setState({ tipo: this.props.match.params.tipo, fornitoreid: this.props.match.params.id });
    if (this.tipo != "A") {
      let config = {
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };
      this.setState({ loading: true });
      var quer = id;
      axios
        .get(Costanti.UrlCallApi + "fornitore/" + quer, config)
        .then((res) => {
          this.setState({ dati: res.data, loading: false });
          //alert(JSON.stringify(this.state.prodotti))
        })
        .catch((error) => {
          alert(error);
        });
    }
  }

  inviaDati(dati) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ isSubmitting: true });
    if (this.state.tipo != "A") {
      if (this.state.tipo == "D") {
        dati.status = "E";
      }

      axios
        .post(Costanti.UrlCallApi + "fornitore/salva/" + this.state.fornitoreid, dati, config)
        .then((res) => {
          this.showMessage("success", "Dati salvati correttamente", "");
          this.setState({ isSubmitting: false });
        })
        .catch((error) => {
          this.showMessage("error", "Errore nel salvataggio", error.message);
          this.setState({ isSubmitting: false });
        });

      setTimeout(() => this.props.history.push("/listaFornitori"), 1000);
    } else {
      dati.aziendaid = this.utente.aziendaid;
      axios
        .post(Costanti.UrlCallApi + "fornitore/aggiungi", dati, config)
        .then((res) => {
          this.showMessage("success", "Dati salvati correttamente", "");
          this.setState({ isSubmitting: false, tipo: "U" });
        })
        .catch((error) => {
          this.showMessage("error", "Errore nel salvataggio", error.message);
          this.setState({ isSubmitting: false });
        });
    }
  }
  render() {
    return (
      <div className="flex">
        <Toast ref={(el) => (this.toastBC = el)} position="bottom-center" />
        <Formik
          initialValues={{
            ragionesociale: this.state.dati.ragionesociale,
            email: this.state.dati.email,
            sede: this.state.dati.sede,
            pec: this.state.dati.pec,
            telefono: this.state.dati.telefono,
            info: this.state.dati.info,
            partitaiva: this.state.dati.partitaiva,
            codicefiscale: this.state.dati.codicefiscale,
            sitoweb: this.state.dati.sitoweb,
            fornitura: this.state.dati.fornitura,
            status: " ",
          }}
          enableReinitialize
          validationSchema={this.validationSchema}
          onSubmit={(values) => {
            this.inviaDati(values);
          }}
        >
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <div className="surface-ground ">
                <div className="text-600 font-medium text-600 text-xl mb-3">
                  <Button onClick={() => this.props.history.push("/listaFornitori")} icon="pi pi-history" />
                  Fornitore
                </div>
                <div className="surface-card p-2  border-round">
                  <div className="grid formgrid p-fluid">
                    <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>

                    <div className="field mb-1 col-12 md:col-6">
                      <label htmlFor="ragionesociale" className="font-medium text-600">
                        Ragione Sociale
                      </label>
                      <InputText
                        name="ragionesociale"
                        value={values.ragionesociale}
                        readOnly={!this.state.editMode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="text"
                      />
                    </div>
                    <div className="field mb-1 col-12 md:col-6">
                      <label htmlFor="sede" className="font-medium text-600">
                        Sede Principale
                      </label>
                      <InputText
                        name="sede"
                        value={values.sede}
                        readOnly={!this.state.editMode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="text"
                      />
                    </div>
                    <div className="field mb-1 col-12 md:col-6">
                      <label htmlFor="partitaiva" className="font-medium text-600">
                        Partita Iva
                      </label>
                      <InputText
                        name="partitaiva"
                        value={values.partitaiva}
                        readOnly={!this.state.editMode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="text"
                      />
                    </div>
                    <div className="field mb-1 col-12 md:col-6">
                      <label htmlFor="telefono" className="font-medium text-600">
                        Telefono
                      </label>
                      <InputText
                        name="telefono"
                        value={values.telefono}
                        readOnly={!this.state.editMode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="text"
                      />
                    </div>
                    <div className="field mb-1 col-12 md:col-6">
                      <label htmlFor="email" className="font-medium text-600">
                        Email
                      </label>
                      <InputText
                        name="email"
                        value={values.email}
                        readOnly={!this.state.editMode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="text"
                      />
                    </div>
                    <div className="field mb-1 col-12 md:col-6">
                      <label htmlFor="pec" className="font-medium text-600">
                        Pec
                      </label>
                      <InputText
                        name="pec"
                        value={values.pec}
                        readOnly={!this.state.editMode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="text"
                      />
                    </div>
                    <div className="field mb-1 col-12 md:col-6">
                      <label htmlFor="website2" className="font-medium text-600">
                        Sito Web
                      </label>
                      <div className="p-inputgroup">
                        <InputText
                          name="sitoweb"
                          value={values.sitoweb}
                          readOnly={!this.state.editMode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          type="text"
                        />
                      </div>
                    </div>
                    <div className="field mb-1 col-12 md:col-6">
                      <label htmlFor="fornitura" className="font-medium text-600">
                        Fornitura
                      </label>
                      <InputText
                        name="fornitura"
                        value={values.fornitura}
                        readOnly={!this.state.editMode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="text"
                      />
                    </div>

                    <div className="field mb-1 col-12 md:col-6">
                      <label htmlFor="info" className="font-medium text-600">
                        Note Aggiuntive
                      </label>
                      <InputTextarea
                        id="info"
                        type="text"
                        rows={10}
                        autoResize
                        value={values.info}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </div>
                    <div className="field mb-1 col-12 md:col-6">
                      <label htmlFor="avatar2" className="font-medium text-600">
                        Logo Azienda
                      </label>
                      <div className="flex align-items-center">
                        <img
                          src={
                            Costanti.UrlCallApi +
                            "file/get/" +
                            this.utente.aziendaid +
                            "/fornitore/" +
                            this.state.fornitoreid
                          }
                          width="20%"
                          alt=""
                          className="mr-4"
                        />
                        <FileUpload
                          id="avatar2"
                          mode="basic"
                          name="avatar"
                          onError={() =>
                            this.showMessage("error", "Errore", "Si è verificato un errore nel caricamento")
                          }
                          url={
                            Costanti.UrlCallApi +
                            "file/carica/" +
                            this.utente.aziendaid +
                            "/fornitore/" +
                            this.state.fornitoreid
                          }
                          onUpload={() => window.location.reload(false)}
                          accept="image/*"
                          maxFileSize={10000000}
                          chooseOptions={{ className: "p-button-plain p-button-outlined" }}
                          chooseLabel="Upload Image"
                        />
                      </div>
                    </div>
                    <div className="surface-border border-top-1 opacity-50 mb-3 col-12 "></div>
                    <div className="col-12 md:col-3" />
                    <div className="col-12 md:col-6">
                      <div className="mb-1 flex align-items-center justify-content-between">
                        <Button type="submit" visible={this.state.tipo == "A"} icon="pi pi-save" label="Aggiungi" />
                        <Button type="submit" visible={this.state.tipo == "U"} icon="pi pi-save" label="Salva" />
                        <Button visible={this.state.tipo == "D"} icon="pi pi-save" label="Elimina" />

                        {this.utente.ruoloid == 31000 ? (
                          <Button
                            label="Notarizza"
                            type="button"
                            icon="pi pi-building"
                            className="p-button-rounded p-button-warning "
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    );
  }
}

export default Fornitore;
